define('helpers/analytics-helper',['require','evertrue','raven'],function(require) {
  var AnalyticsHelper, EverTrue, Raven;
  EverTrue = require("evertrue");
  Raven = require("raven");
  return AnalyticsHelper = {
    setFullStoryUser: function(user) {
      var error;
      try {
        if (typeof FS !== "undefined" && FS !== null) {
          if (typeof FS.identify === "function") {
            FS.identify(user.get("id"), {
              displayName: user.get("name"),
              email: user.get("email"),
              internalUser_bool: user.get("super_user")
            });
          }
        }
        if (EverTrue.conf.disableFsConsole) {
          return typeof FS !== "undefined" && FS !== null ? typeof FS.disableConsole === "function" ? FS.disableConsole() : void 0 : void 0;
        }
      } catch (_error) {
        error = _error;
        return Raven != null ? Raven.captureException(error) : void 0;
      }
    }
  };
});

//# sourceMappingURL=analytics-helper.js.map
;
